module.exports = __webpack_public_path__ + "media/images/icons/comment-plus-dark-744404eff36a02b97265bf5e7984ed7b.svg";